<script setup lang="ts">
  import { KsButton } from '@aschehoug/kloss'
  import { computed } from 'vue'

  const props = withDefaults(defineProps<{
    currentPage: number
    itemCount: number
    pageSize?: number
  }>(), {
    pageSize: 10
  })

  const emit = defineEmits(['pushPage'])

  const totalPages = computed(() =>
    Math.ceil(props.itemCount / (props.pageSize))
  )

  const pages = computed(() => Array.from(new Array(totalPages.value), (_, i) => i + 1))

  const pushExactPage = (page: number) => emit('pushPage', page)
</script>

<template>
  <nav aria-label="Sidenavigasjon" class="pronunciation-pagination">
    <ul>
      <li
        v-for="pageNumber in pages"
        :key="`page-${pageNumber}`"
      >
        <KsButton
          :variant="currentPage === pageNumber ? 'primary' : 'border'"
          :aria-label="`Side ${pageNumber}`"
          shape="square"
          :aria-current="currentPage === pageNumber ? 'page' : false"
          class="page-button"
          @click.prevent="pushExactPage(pageNumber)"
        >
          {{ pageNumber }}
        </KsButton>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
  ul {
    display: flex;
    gap: .5rem;
    padding: 0;
  }

  ul li {
    list-style: none;
  }

</style>